import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=1bcfd975&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfd975",
  null
  
)

export default component.exports